const {now, merge} = require('lodash');
const querystring = require('querystring');
const jsSHA = require("jssha");
const { btoa, atob } = require('abab');

const  _base64Char = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/= ';
const  _aa64Char   = '2tWwxBK1DuvAF3GpH4oSyIJfgNhQ5LqrCsM6O~7RdTUb8ijkVXEY9nZaPc[el]mz0+';

function _reverse(str) {
    let result =  '';
    for (let i=0; i < str.length; i++) {
        result = str.charAt(i) + result;
    }
    return result ;
}

function _tr(str,from,to){
    let result='';
    for (let i=0; i < str.length; i++) {
        result = result + to.charAt(from.indexOf(str.charAt(i)));
    }
    return result;
}

function _encodeAA(str){
    return _tr(_reverse(btoa(str)),_base64Char,_aa64Char);
}

function _decodeAA(str) {
    return atob(_reverse(_tr(str,_aa64Char,_base64Char)));
}

function _encodeObject(object) {
    return _encodeAA(querystring.encode(object));
}

const b64_sha1 = (text) => {
    const shaObj = new jsSHA("SHA-1", "TEXT");
    shaObj.update(text);
    return shaObj.getHash("B64");
};

const hex_sha1 = (text) => {
    const shaObj = new jsSHA("SHA-1", "TEXT");
    shaObj.update(text);
    return shaObj.getHash("HEX");
};

module.exports = {
    encode: function(name, pw, info, options) {
        options = merge({
            shaPassword:false,
            encodePassword:false
        },options);

        const time = Math.ceil(now() / 1000);
        const passwordHash = time +"~"+ (options.shaPassword ? pw : b64_sha1(pw));
        const password = options.encodePassword ? _encodeAA(passwordHash) : hex_sha1(passwordHash);

        return _encodeObject( merge({},info,{
            userName: name, // AOD uses this
            name,   // MiAD?
            password,
            time
        }));
    },
    encodeObject: _encodeObject
};
